import React from 'react'
import { Route, Routes } from "react-router-dom"
import Navbar from '../Components/Navbar'
import { LoginPage } from '../Pages/LoginPage'
import { RegisterationPage } from '../Pages/RegisterationPage'
import { SearchResultPage } from '../Pages/SearchResultPage'
import SectionNews from '../Components/SectionNews'
import { HomePage } from "../Pages/HomePage"
import {SectionHome} from "../Pages/SectionHome"
import AdminRoutes from '../Pages/AdminRoutes'
const Routest = () => {
    return (
        <>
            <Navbar/>
            <Routes>
                <Route exact path="/" element={<HomePage />} />
                <Route path="/Home" element={<HomePage />} />
                <Route path="/registeration" element={<RegisterationPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/search" element={<SearchResultPage />} />
                <Route path="/article/:name" element={<SectionNews />} />
                <Route path="/news/:title" element={<SectionHome />} />
                <Route path="Articles/:title" element={<SectionHome />} />
                <Route path="/admin/*" element={<AdminRoutes />} />
            </Routes>
        </>
    )
}

export default Routest
